import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 7l-4 -4l-4 4","key":"svg-0"}],["path",{"d":"M17 3v11a3 3 0 0 1 -3 3h-11","key":"svg-1"}],["path",{"d":"M7 13l-4 4l4 4","key":"svg-2"}]]

const IconArrowsUpLeft = createReactComponent('outline', 'arrows-up-left', 'ArrowsUpLeft', __iconNode);

export default IconArrowsUpLeft;